import { fetchUtils } from "react-admin";

const fetchJson = (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: "application/json" });
  }
  const token = localStorage.getItem("access_token");
  if (token) {
    options.headers.set("Authorization", `Bearer ${token}`);
  }
  return fetchUtils.fetchJson(url, options);
};

const httpClient = (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: "application/json" });
  }
  const token = localStorage.getItem("access_token");
  if (token) {
    options.headers.set("Authorization", `Bearer ${token}`);
  }
  return fetch(url, options);
};

export { fetchJson, httpClient };
